import { render, staticRenderFns } from "./DatatableVehicleKtypes.vue?vue&type=template&id=222353f8"
import script from "./DatatableVehicleKtypes.vue?vue&type=script&lang=js"
export * from "./DatatableVehicleKtypes.vue?vue&type=script&lang=js"
import style0 from "./DatatableVehicleKtypes.vue?vue&type=style&index=0&id=222353f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports